/*
 * @Author: wen.chen02@hand-china.com
 * @Description: 二开模块统一配置文件
 */
/**
 * 设计器生成源代码 - 每个组件的唯一key索引名
 */
export const componentKey = 'data-hcg_flag';
